import { RELOAD_CURRENT_TAB, RELOAD_ALL_TABS } from './constants';

export const reloadCurrentTabAction = () => ({ type: RELOAD_CURRENT_TAB });
export const reloadAllTabsAction = () => ({ type: RELOAD_ALL_TABS });
